<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisible"
        width="60%"
        :destroy-on-close="true"
        :before-close="handleClose">
    <div style="width:70%;margin-left:5%;">
        <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
            <el-form-item label="认证用户" >
                <el-input v-model="formLabelAlign.userName" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="认证类型" >
                <el-input v-model="formLabelAlign.idName" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="认证房间地址" >
                <el-input v-model="formLabelAlign.address" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人姓名" >
                <el-input v-model="formLabelAlign.applyName" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人手机号" >
                <el-input v-model="formLabelAlign.applyTel" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="预留业主" >
                <el-input v-model="formLabelAlign.cusName" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="预留电话" >
                <el-input v-model="formLabelAlign.cusTel" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="填写业主姓名" >
                <el-input v-model="formLabelAlign.applyCusName" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="填写业主电话" >
                <el-input v-model="formLabelAlign.applyCusTel" size="small" disabled></el-input>
            </el-form-item>
            <el-form-item label="上传图片" >
                <el-image style="width: 100px; height: 100px" :src="formLabelAlign.imgUrls"></el-image>
            </el-form-item>
            <el-form-item label="审核原因" >
                <el-input v-model="auditComment" size="small" ></el-input>
            </el-form-item>
        </el-form>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="this.title == '审核'" @click="Refuse()" v-debounce>拒 绝</el-button>
        <el-button type="primary" v-if="this.title == '审核'" @click="modification()" v-debounce>通 过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RoomBindingDialog",
  data() {
    return {
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',


    auditComment:"",
    formLabelAlign:{},
    };
  },
  watch:{
      dialogVisible(val){
          if(val == true){
              if(this.title == "审核"){
                  this.auditComment = ""
              }
          }
      }
  },
  methods: {
    modification(){
        let obj = {
            "id":this.formLabelAlign.id,
            "auditComment":this.auditComment,
            "auditRes":"1",
        }
        this.$http.post(this.$requestUrl.POST_AUDIT_REFUSED,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.dialogVisible = false
              this.$emit("Visible",false)
                this.$message({
                message: '审核通过',
                type: 'success'
                });
          } else {
           this.$message({
            message: '审核失败',
            type: 'warning'
          });        
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    Refuse(){
      let obj = {
          "id":this.formLabelAlign.id,
          "auditComment":this.auditComment,
          "auditRes":"-1",
      }
      this.$http.post(this.$requestUrl.POST_AUDIT_REFUSED,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.dialogVisible = false
              this.$emit("Visible",false)
                this.$message({
                message: '审核拒绝',
                type: 'success'
                });
          } else {
           this.$message({
            message: '审核失败',
            type: 'warning'
          });
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })

    },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
       
    
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>